import { render, staticRenderFns } from "./handpickCategoryAdd.vue?vue&type=template&id=77f72f8c&scoped=true&"
import script from "./handpickCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./handpickCategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./handpickCategoryAdd.vue?vue&type=style&index=0&id=77f72f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f72f8c",
  null
  
)

export default component.exports